var baseUrl = 'https://oss-dffl-icons.dongfangfuli.com';

var getUrl = function getUrl(env) {
  return "".concat(baseUrl, "/").concat(env, "/dffl-icons.js");
};

export var test05Url = getUrl('test05');
export var stageUrl = getUrl('stage');
export var prdUrl = getUrl('prd');